import axios from 'axios'
import store from '~/store'
import router from '~/router'
import i18n from './vue-i18n'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.request.use(request => {
  if (store.getters['auth/token']) {
    request.headers.common['Authorization'] = `Bearer ${store.getters['auth/token']}`
  }
  return request
})

axios.interceptors.response.use(response => response, error => {
  const { status } = error.response
  // const cheats = [993, 990]
  if (status >= 500) {
    store.dispatch('logAxios', {
      type: 'error',
      restaurant_id: store.getters['config/rid'],
      url: error.response.config.url,
      data: error.response.config.data,
      message: error.response.data.message,
      file: error.response.data.file,
      line: error.response.data.line,
      headers: error.response.headers
    })
    // if (!cheats.includes(parseInt(store.getters['config/rid']))) {
    //   store.dispatch('responseMessage', {
    //     type: 'error',
    //     text: 'System encountered an error. Please try again later.',
    //     title: 'System Error',
    //     modal: true
    //   })
    // }
  }

  if (status === 401 && store.getters['auth/authenticated']) {
    store
      .dispatch('responseMessage', {
        type: 'warning',
        text: i18n.t('token_expired_alert_text'),
        title: i18n.t('token_expired_alert_title'),
        modal: true
      })
      .then(async () => {
        await store.dispatch('auth/logout')
        await store.dispatch('resetAllData')

        router.push({ name: 'login' })
      })
  }

  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/plugins/axios.js